



























































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Surface, Typography, TextField, Checkbox } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';

import AdminService from '@/api/AdminService';

import eventBus from '@/utils/eventBus';
import { treatError } from '@/utils';

@Component({
  components: { Surface, Typography, TextField, FilledButton, Checkbox }
})
export default class TransferOwnershipModal extends Vue {
  @Prop() readonly business?: any;

  service: AdminService = new AdminService();
  name: string = '';
  mail: string = '';
  loading?: boolean = false;
  confirmSelection: boolean = false;
  removePreviousOwner: boolean = false;

  onClose() {
    eventBus.$emit('closeModal');
  }

  async confirmOwnershipTransfer() {
    try {
      this.loading = true;
      await this.service.transferBusinessOwnership(
        this.business.id,
        this.mail,
        this.name,
        this.removePreviousOwner
      );

      this.$notification('Ownership successfully transfered');
      eventBus.$emit('reloadBusinessOwnershipList');
      eventBus.$emit('closeModal');
    } catch (res) {
      this.$notification(treatError(res));
    } finally {
      this.loading = false;
    }
  }
}
